import { createElementVNode as _createElementVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d5f48e18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid mx-0" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "overlay d-none d-lg-block" }, null, -1))
const _hoisted_3 = { class: "row d-flex align-items-center vh-sm-100" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6 vh-sm-100 background-image d-flex p-5 align-items-stretch" }, [
  /*#__PURE__*/_createElementVNode("a", { class: "navbar-brand navbar-brand-white" })
], -1))
const _hoisted_5 = { class: "col-lg-6 d-flex justify-content-center align-items-center" }
const _hoisted_6 = { class: "w-75 py-5" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mb-4" }, "Enter your code", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Enter your code below. You will need this every time you wish to enter. ", -1))
const _hoisted_9 = { class: "mt-4 mb-2" }
const _hoisted_10 = { class: "form-floating" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "uniqueCode" }, "Enter your Code", -1))
const _hoisted_12 = {
  key: 0,
  class: "text-danger mt-3"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-circle-fill" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fs-6" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "",
    "data-bs-toggle": "modal",
    "data-bs-target": "#exampleModal"
  }, "I don't have a code yet")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" By clicking Login you are agreeing to our user "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.guiide.co.uk/Home/TermsandConditions",
    target: "_blank"
  }, "terms and conditions"),
  /*#__PURE__*/_createTextVNode(" and "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.guiide.co.uk/Home/PrivacyPolicy",
    target: "_blank"
  }, "privacy policy"),
  /*#__PURE__*/_createTextVNode(". ")
], -1))
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"modal fade\" id=\"exampleModal\" tabindex=\"-1\" aria-labelledby=\"exampleModalLabel\" aria-hidden=\"true\" data-v-d5f48e18><div class=\"modal-dialog modal-dialog-centered\" data-v-d5f48e18><div class=\"modal-content\" data-v-d5f48e18><div class=\"modal-header bg-primary text-white\" data-v-d5f48e18><h5 class=\"modal-title\" id=\"exampleModalLabel\" data-v-d5f48e18>Unique Code</h5><button type=\"button\" class=\"btn-close btn-close-white\" data-bs-dismiss=\"modal\" aria-label=\"Close\" data-v-d5f48e18></button></div><div class=\"modal-body\" data-v-d5f48e18><p data-v-d5f48e18> For some schemes you will have received a specific code in your transfer value pack. If your scheme does not provide a specific code in this pack, follow the instructions on the previous page, using the two letters provided added to the front of your scheme membership number </p></div></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("input", {
                  ref: "userCode",
                  type: "text",
                  id: "uniqueCode",
                  name: "uniqueCode",
                  class: "form-control unique-code form-control-lg w-auto",
                  maxlength: "12",
                  placeholder: "Enter your Code",
                  onKeyup: _cache[0] || (_cache[0] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onNextClicked && _ctx.onNextClicked(...args)), ["enter"]))
                }, null, 544),
                _hoisted_11,
                (_ctx.showInvalidCodeMessage)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
                      _hoisted_13,
                      _createTextVNode(" Please enter a valid code or email contact@guiide.co.uk to request one. ")
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _hoisted_14,
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary mb-4",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onNextClicked && _ctx.onNextClicked(...args)))
            }, " Login "),
            _hoisted_15
          ])
        ])
      ])
    ]),
    _hoisted_16
  ], 64))
}